<template>
  <div class="searchDoctor">
    <div class="banner">
      <img src="@/assets/index/banner.png" />
      <div class="Note">
        <router-link to="/hospitalRegister" tag="div">
          <img src="@/assets/index/reservation.png" />
        </router-link>
        <!-- <router-link to="/nucleicTest" tag="div">
          <img src="@/assets/index/nucleic_acid_test.png" />
        </router-link> -->
      </div>
      <img src="@/assets/index/user_icon.png" class="user_icon" />
      <!-- <img :src="user.userOpen?user.userOpen.headimgurl:'#'" class="user_icon"> -->
      <!-- <div class="tabPatient" @click="addren">
        
      </div> -->
      <span class="clname">
        <span>{{
          bVisitinfoList.length != 0 ? currentSel.patientname : "请选择就诊人"
        }}</span>
        <span class="tabPatient" @click="addren">切换就诊人</span>
      </span>
      <span class="clkahao"
        >就诊ID号：{{
          bVisitinfoList.length != 0 ? currentSel.patientId : "无"
        }}</span
      >
      <div class="Visit_Card" @click="go">
        <img src="@/assets/index/Visit_Card.png" />
        <span>就诊卡</span>
      </div>
    </div>
    <div class="department">
      <!-- 门诊服务 -->
      <div class="typeface">门诊服务</div>
      <router-link to="/outpatientDepartment" tag="div">
        <img src="@/assets/index/payment.png" />
      </router-link>
      <router-link to="/paymentRecord" tag="div">
        <img src="@/assets/index/pay.png" />
      </router-link>
      <router-link to="/mySubscribe" tag="div">
        <img src="@/assets/index/register.png" />
      </router-link>
      <!-- <router-link to tag="div">
        <img src="@/assets/index/examination.png" @click="tips" />
      </router-link> -->
      <router-link to="/Report" tag="div">
        <img src="@/assets/index/Inspection.png" />
      </router-link>
      <router-link to="/PriceInquiry" tag="div">
        <img src="@/assets/index/Price_inquiry.png" />
      </router-link>
      <!-- <router-link to tag="div">
        <img src="@/assets/index/evaluate.png" @click="tips" />
      </router-link> -->
      <router-link to="/questionnaire" tag="div">
        <img src="@/assets/index/Satisfaction.png" />
      </router-link>
      <div class="kong"></div>
      <div class="kong"></div>
    </div>
    <!-- 住院服务 -->
    <div class="department" style="margin-top: 6px">
      <div class="typeface">住院服务</div>
      <router-link to="/OutpatientDeposit" tag="div">
        <img src="@/assets/index/Recharge.png" />
      </router-link>
      <!-- <router-link to tag="div">
        <img src="@/assets/index/be_hospitalized.png" @click="tips" />
      </router-link> -->
      <!-- <router-link to tag="div">
        <img src="@/assets/index/settlement.png" @click="tips" />
      </router-link> -->
      <!-- <router-link to="/MicroStation" tag="div">
        <img src="@/assets/index/remind.png" />
      </router-link> -->
      <router-link to="/GeneralList" tag="div">
        <img src="@/assets/index/Daily_list.png" />
      </router-link>
      <div class="kong"></div>
      <div class="kong"></div>
    </div>
    <!-- 医院信息 -->
    <div class="department" style="margin-top: 6px">
      <div class="typeface">医院信息</div>
      <router-link to="/website" tag="div">
        <img src="@/assets/index/wgw.jpg" />
      </router-link>
    </div>
    <!-- <van-overlay :show="show" z-index="9999">
      <div class="block">
        <div>
          <p>
            <img src="@/assets/index/notice.png" />
            <span>科室公告</span>
          </p>
          <p>
            根据疫情防控要求，急诊患者和到呼吸内、耳鼻喉科、口腔科、消化内镜中心就诊的患者，
            <span style="font-weight: bold; color: red"
              >须持48小时内核酸阴性结果，并在门诊预检分诊同步进行核酸采样</span
            >，先采样，后就诊。
          </p>
          <van-button round block type="info" @click="close"
            >好，我已了解</van-button
          >
        </div>
      </div>
    </van-overlay> -->
  </div>
</template>

<script>
import { selectVisitinfos } from "@/request/api.js";
import top from "@/components/Header/header";
import { Dialog } from "vant";
import { Base64 } from "js-base64";
import QRCode from "qrcodejs2";
export default {
  components: {
    top
  },
  data() {
    return {
      user: {},
      bVisitinfoList: [],
      currentSel: {},
      show: false
    };
  },
  async created() {
    if(sessionStorage.getItem("card")){
      this.bVisitinfoList = [];
      this.bVisitinfoList.push(JSON.parse(sessionStorage.getItem("card")));
      this.currentSel = JSON.parse(sessionStorage.getItem("card"));
    } else {
      this.show = true;
      var hspCode = window.location.href;
      var token = hspCode.split("?")[1];
      // let token = "eyJiVmlzaXRpbmZvTGlzdCI6W3siYWRkcmVzcyI6IumVv+aymeW4guWys+m6k+WMuiIsImNhcmRubyI6IjIzNDIzNTIzNSIsImRhdGVvZmJpcnRoIjo3ODcxNjE2MDAwMDAsImlkY2FyZG5vIjoiNDMwMTA0MTk5NDEyMTIxMjE0IiwicGF0aWVudG5hbWUiOiLmtYvor5UiLCJzZXgiOiLnlLciLCJzdHlsZSI6MSwidGVsbm8iOiIxODc3Nzc3Nzc3NyJ9XSwidXNlck9wZW4iOnsiaGVhZGltZ3VybCI6Imh0dHBzOi8vdGhpcmR3eC5xbG9nby5jbi9tbW9wZW4vdmlfMzIvUTBqNFR3R1RmVElSM1dIUTdUaWNtWVlERHZXdlRBbU9PWDdMVUVrWE05OERZMkV4eXFYdnhGaFpOcndrcWVEaWJQMkMzRzcxQm54aWM3a1ZaenBONkV3RWcvMTMyIiwib3BlbmlkIjoib3RuRlI1NGJ3bkVuRk4xWU9GRU05RTU5Q1dRSSJ9fQ=%3D";
      // let token = "eyJiVmlzaXRpbmZvTGlzdCI6W3siYWRkcmVzcyI6IuWMl%20S6rOW4guWMl%20S6rOW4guS4nOWfjuWMujExMSIsImNhcklkIjoyLCJjYXJkbm8iOiI0NDE0MjEyMDAwMDcxODI3MVgiLCJjcmVhdGVkYXRlIjoxNjY3NTUwNzIzMDAwLCJkYXRlb2ZiaXJ0aCI6OTYzODQ5NjAwMDAwLCJpZGNhcmRubyI6IjQ0MTQyMTIwMDAwNzE4MjcxWCIsIm5hdGlvbiI6IuaxieaXjyIsIm9wZW5pZCI6Im90bkZSNTRid25FbkZOMVlPRkVNOUU1OUNXUUkiLCJwYXRpZW50SWQiOiI0NDE0MjEyMDAwMDcxODI3MVgiLCJwYXRpZW50bmFtZSI6IuWPtuajruadgyIsInNleCI6IueUtyIsInN0eWxlIjowLCJ0ZWxubyI6IjE1ODc2NzI5MzIzIn1dLCJ1c2VyT3BlbiI6eyJjYXJ0ZGF0ZSI6MTY2NzQ1NDM0NTAwMCwiZW1JZCI6MiwiaGVhZGltZ3VybCI6Imh0dHBzOi8vdGhpcmR3eC5xbG9nby5jbi9tbW9wZW4vdmlfMzIvUTBqNFR3R1RmVElSM1dIUTdUaWNtWVlERHZXdlRBbU9PWDdMVUVrWE05OERZMkV4eXFYdnhGaFpOcndrcWVEaWJQMkMzRzcxQm54aWM3a1ZaenBONkV3RWcvMTMyIiwibmlja25hbWUiOiLlpZUiLCJvcGVuaWQiOiJvdG5GUjU0YnduRW5GTjFZT0ZFTTlFNTlDV1FJIiwic2V4IjoiMCJ9fQ=%3D";
      token = decodeURIComponent(token).replace(/\s/g, "+"); // decodeURIComponent() 对编码后的 URI 进行解码;
      let user = Base64.decode(token);
      this.user = JSON.parse(user);
      this.getLists();
      sessionStorage.setItem("user", user);
      sessionStorage.setItem("openid", this.user.userOpen.openid);
    }
  },
  activated() {
    if(sessionStorage.getItem("card")){
      this.bVisitinfoList = [];
      this.bVisitinfoList.push(JSON.parse(sessionStorage.getItem("card")));
      this.currentSel = JSON.parse(sessionStorage.getItem("card"));
    } else {
      this.getLists();
    }
  },
  mounted() {
    // var hspCode = window.location.href;
    // var _datass = hspCode.split("=")[1];
    // sessionStorage.removeItem("huixian");
  },
  methods: {
    async getLists() {
      let res = await selectVisitinfos({ openid: this.user.userOpen.openid });
      this.bVisitinfoList = res.data.obj;
      this.bVisitinfoList.forEach(item => {
        if (item.style == 1) {
          this.currentSel = item;
          sessionStorage.setItem("card", JSON.stringify(item));
        }
      });
      if (this.bVisitinfoList.length == 0) {
        Dialog.alert({
          message: "无就诊卡请前往建卡页面"
        }).then(() => {
          this.$router.push("/AddVisitors");
        });
      }
    },
    tips() {
      this.Toast("此功能暂未开通");
    },
    addren() {
      this.$router.push("/MedicalCard");
    },
    go(){
      this.$router.push("/HealthCard");
    },
    close() {
      this.show = false;
      this.getLists();
    }
  }
};
</script>

<style lang="less" scoped>
.searchDoctor {
  width: 100%;
  height: 100%;
  // display: flex;
  // flex-direction: column;
  background-color: #f5f5f7;
  .banner {
    width: 100%;
    position: relative;
    > img {
      width: 100%;
    }
    .Note {
      background-color: #fff;
      position: absolute;
      width: 100%;
      height: 96px;
      top: 156px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: center;
      align-items: center;
      img {
        // width: 183px;
        // height: 67px;
        width: 240px;
        height: 86px;
      }
    }
    .user_icon {
      position: absolute;
      width: 51px;
      height: 51px;
      top: 94px;
      left: 27px;
      border-radius: 50%;
    }
    .tabPatient {
      // position: absolute;
      // top: 105px;
      // left: 140px;
      margin-left: 4px;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #6098ff;
    }
    .clname {
      position: absolute;
      top: 100px;
      left: 86px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #000000;
    }
    .clkahao {
      position: absolute;
      top: 120px;
      left: 86px;
      font-size: 13px;
    }
    .Visit_Card {
      position: absolute;
      top: 98px;
      left: 301px;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
      > img {
        width: 32px;
        height: 32px;
      }
      > span {
        font-size: 10px;
        padding-top: 2px;
      }
    }
  }
  .department {
    width: 100%;
    // height: 216px;
    padding: 38px 10px 12px;
    box-sizing: border-box;
    background-color: #fff;
    margin-top: 3px;
    display: flex;
    position: relative;
    flex-flow: row wrap;
    justify-content: space-between;
    img {
      width: 88px;
      height: 82px;
    }
    .kong {
       width: 88px;
      height: 82px;
    }
    .typeface {
      position: absolute;
      top: 12px;
      left: 20px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      line-height: 25px;
      color: #000000;
      opacity: 1;
    }
  }
  .block {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    > div {
      width: 288px;
      background: #fff;
      border-radius: 10px;
      padding: 28px 22px;
      > p:nth-child(1) {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        > img {
          width: 25px;
          height: 25px;
        }
        > span {
          margin-left: 16px;
          font-size: 17px;
          font-weight: bold;
        }
      }
      > p:nth-child(2) {
        margin: 24px 10px;
        letter-spacing: 1px;
        font-size: 14px;
        color: #707070;
        line-height: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Index/index.vue